"use client";

import React, { Component, ErrorInfo, ReactNode } from "react";
import { ErrorState } from "@/components/ui/states/ErrorState";
import { errorCopy } from "@/lib/errorCopy";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      const t = errorCopy();

      return (
        <div className="flex min-h-screen items-center justify-center bg-background">
          <ErrorState
            title={t.title}
            message={t.message}
            onRetry={this.handleReset}
            retryLabel={t.retry}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
